enum RobotType {
    Unattended = 0,
    Studio = 1
}

const RobotTypeValue = {
    GetText: (typeNumber: number) => {
        return RobotType[typeNumber].valueOf()
    }
}

export default RobotTypeValue